import { useQuery } from "react-query";
import endpoints from "./EndPoints"
import { getAdvertImages, getContractTypeById, getDocumentByAdvert, getDopingList,  } from "./Services";


export const useGetAdvertImages = (adId:string) => {
  return useQuery([endpoints.getMediaByAdvert], () => getAdvertImages(adId), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};
export const useGetDocumentByAdvert = (adId:string) => {
  return useQuery([endpoints.getDocumentByAdvert], () => getDocumentByAdvert(adId), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetContractByType= (typeId:string) => {
  return useQuery([endpoints.getContractTypeById,typeId], () => getContractTypeById(typeId), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export const useGetDopings= () => {
  return useQuery([endpoints.getDopings], () => getDopingList(), {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};



